import moment from 'moment-timezone';

export const formatDateTime = (date) => {
    const centralTime = moment.utc(date).tz('America/Chicago');
    return `${centralTime.format('HH:mm')} CST ${centralTime.format('MM/DD/YYYY')}`;
};
